import { IContainerSelectorFactory } from '../../model/containers/IContainerSelectorFactory';
import { IContainerReactRenderer } from './IContainerReactRenderer';
import { ScreenshotRequestContainerRenderer } from './ScreenshotRequestContainerRenderer';
import { TextContainerRenderer } from './TextContainerRenderer';
import { UnknownContainerRenderer } from './UnknownContainerRenderer';

export interface IContainerReactRendererFactory extends IContainerSelectorFactory<IContainerReactRenderer> {
}

export class ContainerReactRendererFactory implements IContainerReactRendererFactory {
  getScreenshotRequest(): IContainerReactRenderer<any> {
    return new ScreenshotRequestContainerRenderer();
  }
  getUnknown(): IContainerReactRenderer<any> {
    return new UnknownContainerRenderer();
  }
  getText(): IContainerReactRenderer<any> {
    return new TextContainerRenderer();
  }
}